import { render, staticRenderFns } from "./CartItemInfo.vue?vue&type=template&id=455fbf7c&scoped=true&"
import script from "./CartItemInfo.vue?vue&type=script&lang=js&"
export * from "./CartItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./CartItemInfo.vue?vue&type=style&index=0&id=455fbf7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455fbf7c",
  null
  
)

export default component.exports